<template>
  <div
    :class="[
      'pa-2',
      selected ? 'selected_card' : 'not_selected_card',
      'cd-flex',
      getPosition,
    ]"
    @click.stop="click"
  >
    <div class="font-weight-medium subheading" style="width: 80%">
      <p :class="selected ? 'primary--text' : ''">{{ device.name }}</p>
      <p class="mb-1 grey--text text--darken-2">
        Topic:
        <span class="font-weight-regular">{{ device.topic }}</span>
      </p>
      <p class="mb-1 grey--text text--darken-2">
        Puerta:
        <span class="font-weight-regular">{{ device.door.name }}</span>
      </p>
      <p class="mb-1 grey--text text--darken-2">
        Token:
        <span class="font-weight-regular">{{ device.accessToken }}</span>
      </p>
    </div>
    <div
      style="
        width: 20%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      "
    >
      <v-btn small icon @click="update">
        <v-icon color="black">edit</v-icon>
      </v-btn>
      <v-btn small icon @click="remove">
        <v-icon color="black">delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'middle',
    },
    device: {
      type: Object,
      default: {},
    },
  },
  computed: {
    getPosition() {
      const temp = {
        top: 'top-radius',
        bottom: 'bottom-radius',
        middle: 'middle-radius',
        single: 'top-radius bottom-radius',
      }
      return temp[this.position]
    },
  },
  methods: {
    update() {
      this.$emit('update')
    },
    remove() {
      this.$emit('delete')
    },
    click() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.cd-flex {
  display: flex;
  cursor: pointer;
  transition: background-color 0.3s ease-out;
}
.cd-flex.selected_card:hover {
  background-color: var(--v-primary-lighten4);
}
.cd-flex.not_selected_card:hover {
  background-color: var(--v-gray-lighten3);
}
.top-radius {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-left: 1px solid;
  border-top: 1px solid;
  border-right: 1px solid;
}
.middle-radius {
  border-left: 1px solid;
  border-right: 1px solid;
}
.bottom-radius {
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.selected_card {
  background-color: var(--v-primary-lighten5);
  border-color: var(--v-primary-base);
}
.not_selected_card {
  border-color: var(--v-gray-lighten1);
}
</style>
